import React from "react";
import * as styles from "./loading-spinner.module.css";

const LoadingSpinner = () => <div className={styles.spinner}></div>;

export default LoadingSpinner;
